import React from "react";

const toRecord = (modules: Record<string, { default: string }>): Record<string, string> => {
  const images: Record<string, string> = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, mod] of Object.entries(modules)) {
    // eslint-disable-next-line prefer-template
    const filename = "./" + key.split("/").pop();
    images[filename] = mod.default;
  }
  return images;
};

const imagesData: {
  path: string;
  images: Record<string, string>;
}[] = [
  {
    path: "assets/images",
    images: toRecord(
      import.meta.glob("../../assets/images/*.{png,svg}", { eager: true }) as Record<string, { default: string }>,
    ),
  },
  {
    path: "assets/images/FreightIcons",
    images: toRecord(
      import.meta.glob("../../assets/images/FreightIcons/*.{png,svg}", { eager: true }) as Record<
        string,
        { default: string }
      >,
    ),
  },
  {
    path: "assets/images/icons",
    images: toRecord(
      import.meta.glob("../../assets/images/icons/*.{png,svg}", { eager: true }) as Record<string, { default: string }>,
    ),
  },
  {
    path: "assets/images/icons/TopNavIcons",
    images: toRecord(
      import.meta.glob("../../assets/images/icons/TopNavIcons/*.{png,svg}", { eager: true }) as Record<
        string,
        { default: string }
      >,
    ),
  },
  {
    path: "assets/images/iconsV2",
    images: toRecord(
      import.meta.glob("../../assets/images/iconsV2/*.{png,svg}", { eager: true }) as Record<string, { default: string }>,
    ),
  },
  {
    path: "assets/images/mapMarkers",
    images: toRecord(
      import.meta.glob("../../assets/images/mapMarkers/*.{png,svg}", { eager: true }) as Record<string, { default: string }>,
    ),
  },
  {
    path: "assets/images/widgetIcons",
    images: toRecord(
      import.meta.glob("../../assets/images/widgetIcons/*.{png,svg}", { eager: true }) as Record<
        string,
        { default: string }
      >,
    ),
  },
];

export default function ImageGallery() {
  return (
    <>
      {imagesData.map(({ path, images }) => (
        <div className="p-xl mb-lg" key={path}>
          <h4 className="mb-sm">{path}</h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: "10px",
            }}
          >
            {Object.entries(images).map(([filename, src]) => (
              <div
                key={filename}
                className="d-flex flex-column justify-content-center align-items-center p-xl radius-sm"
                style={{ border: "1px solid #b6b6b6" }}
              >
                <div>
                  <img width={40} src={src} alt={filename} style={{ maxWidth: "40px", height: "auto", maxHeight: "80px" }} />
                </div>
                <p className="font-b3 text-wrap break-all mt-md">
                  {path}
                  {filename.slice(1)}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
